<template>
  <el-col v-if="sectionlist.length > 0" :span="4" class="jo-sidebar" id="jo-sidebar" :style="{ height:slideHeight+'px' }">
    <div class="jo-catalog-title" v-if="ARTICLE.defaultlang=='zh'">目录<span>contents</span></div>
    <div class="jo-catalog-title" v-else-if="ARTICLE.defaultlang=='en'"><span>OUTLINE</span></div>
    <el-scrollbar id="sidebar-items">
      <div class="sidebar-item" :id="item.id + 'side'" v-for="(item, index) in sectionlist" v-bind:key="item.index"
           @click="goAnchor(item.id)" :data-id="item.id"
           :class="[item.level==='1'?'grade-one':'grade-two',(currentSec == item.id && item.id)?'current':'']">
        <span v-if="item.titleEn && item.titleEn != ''" class="sidebar-item-span">
          {{ item.label }}
          <span v-if="lang=='zh'">{{ item.title}}</span>
          <span v-else>{{ item.titleEn}}</span>
        </span>
        <span v-else class="sidebar-item-span">
          <!--等于string的判断应该是以前遗留的兼容问题，目前都改成了数组，可以考虑去掉-->
          <span v-if="typeof item.label == 'string'">{{ item.label }}</span>
          <component v-else :is="'jo' + item2.name" v-for="item2 in item.label" v-bind:key="item2.index"
                     v-bind:data="item2.data"></component>
          <span v-if="typeof item.title == 'string'">{{ item.title }}</span>
          <component v-else :is="'jo' + item2.name" v-for="item2 in item.title" v-bind:key="item2.index"
                     v-bind:data="item2.data"></component>
        </span>
      </div>
    </el-scrollbar>
  </el-col>
</template>

<script>
  import joinlineformula from '../body/formula/inlineformula.vue'
  /* eslint-disable */
  export default {
    components: {
      joinlineformula
    },
    data() {
      return {
        currentSec: '',
        sectionlist: [],
        body: this.ARTICLE.body,
        scrollFlag: false,
        topHeight: 0,
        clientHeight: 0,
        scrollTop: -1,
        lang: this.ARTICLE.defaultlang,
        outSideFooterHeight: 0
      }
    },
    computed: {
      slideHeight() {
        //距离底部的高度
        var scrollToBottom = $(document.body).height() - $(window).scrollTop() - $(window).height()
        var changeHeight = 0;
        //如果距离底部的高度小于footer的高度
        if(scrollToBottom < this.outSideFooterHeight) {
          //计算左侧目录应该减少的高度
          changeHeight = this.outSideFooterHeight - scrollToBottom
          $('.jo-up-btn').css('bottom', 10 + changeHeight + 'px')
        }
        if (this.scrollTop >= this.topHeight){
          //返回动态计算后左侧目录的高度
          return this.clientHeight - changeHeight;
        }
        else
          return this.clientHeight - (this.topHeight - this.scrollTop)
      },
    },
    methods: {
      //锚点跳转
      goAnchor(selector) {
        $('#' + this.currentSec + 'side').css({'color': '#454545', 'border-left-color' : '#efefef'});
        $(window).scrollTop($("#" + selector).offset().top)
        this.currentSec = selector
        if (this.ARTICLE.theme != null && this.ARTICLE.theme != '') {
          $('#' + this.currentSec + 'side').css({'color': this.ARTICLE.theme, 'border-left-color': this.ARTICLE.theme});
        } else {
          $('#' + this.currentSec + 'side').css({'color': '#00a2af', 'border-left-color': '#00a2af'});
        }
        this.scrollFlag = false
      },
      sidebarLocate() {
        this.scrollTop = $(window).scrollTop()
        let pageHeight = 0
        if ($("#page-head").height() && $("#page-head").height() > 0) {
          pageHeight = $("#page-head").height()
        }
        let scrollheight = this.scrollTop - this.topHeight
        // 处理侧边导航条定位变化问题
        if (pageHeight != 0 && scrollheight > pageHeight) {
          $(".jo-sidebar").css({"position": "fixed"})
        }else if(pageHeight == 0 && this.scrollTop - this.topHeight > 0) {
          $(".jo-sidebar").css({"position": "fixed"})
        } else {
          $(".jo-sidebar").css({"position": "relative"})
        }
      },
      handleScroll() {
        //为了解决最底部标题跳转时导致的滚动事件让定位变到上一层
        if (!this.scrollFlag) {
          this.scrollFlag = true
          this.sidebarLocate()
          return
        }
        $('#' + this.currentSec + 'side').css({'color': '#454545', 'border-left-color' : '#efefef'});
        this.sidebarLocate()
        if (this.scrollTop == 0 || this.scrollTop < this.topHeight) {
          this.currentSec = this.sectionlist[0].id
          return
        }
        for (var i = 0; i < this.sectionlist.length - 1; i++) {
          let currentNode = $("#" + this.sectionlist[i].id);
          let nextNode  = $("#" + this.sectionlist[i + 1].id);
          var current = currentNode
            ? currentNode.offset().top
            : 0;
          var next = nextNode
            ? nextNode.offset().top
            : 0;
          //定位减掉头部区域-12.17
          if (this.scrollTop > (current-10) && this.scrollTop < next) {
            this.currentSec = this.sectionlist[i].id;
            break;
          }
        }
        let lastNode = $("#" + this.sectionlist[this.sectionlist.length - 1].id);
        let tempOffsetTop = lastNode
          ? lastNode.offset().top
          : 0;
        if (this.scrollTop >= tempOffsetTop) {
          this.currentSec = this.sectionlist[this.sectionlist.length - 1].id
        }
        if (this.ARTICLE.theme != null && this.ARTICLE.theme != '') {
          $('#' + this.currentSec + 'side').css({'color': this.ARTICLE.theme, 'border-left-color': this.ARTICLE.theme});
        } else {
          $('#' + this.currentSec + 'side').css({'color': '#00a2af', 'border-left-color': '#00a2af'});
        }
      },
      showNode(value) {
        this.$nextTick(() => {
          let scrollTop = $(".el-scrollbar__wrap").scrollTop()
          let contentHeight = $(".el-scrollbar__wrap").outerHeight()
          if($("[data-id=" + value + "]").position()){
            let itemTop = $("[data-id=" + value + "]").position().top
            let itemBottom = itemTop + $("[data-id=" + value + "]").outerHeight()
            if (itemTop < 0) {
              $(".el-scrollbar__wrap").scrollTop(scrollTop + itemTop)
            }
            else if (itemBottom > contentHeight) {
              $(".el-scrollbar__wrap").scrollTop(scrollTop + itemBottom - contentHeight)
            }
          }
        })
      },
      scrollUpFixed: function () {
        // 滚动左侧nav时，阻止窗体正文部分滚动
        return $('#sidebar-items  .el-scrollbar__wrap').each(function () {
          var eventType = 'mousewheel';
          if (navigator.userAgent.indexOf("Firefox") > -1) {
            eventType = 'DOMMouseScroll';
          }
          $(this).on(eventType, function (event) {
            // 一些数据
            var scrollTop = this.scrollTop,
              scrollHeight = this.scrollHeight,
              height = this.clientHeight;

            var delta = (event.originalEvent.wheelDelta) ? event.originalEvent.wheelDelta : -(event.originalEvent.detail || 0);
            if ((delta > 0 && scrollTop <= delta) || (delta < 0 && scrollHeight - height - scrollTop <= -1 * delta)) {
              // IE浏览器下滚动会跨越边界直接影响父级滚动，因此，临界时候手动边界滚动定位
              this.scrollTop = delta > 0 ? 0 : scrollHeight;
              // 向上滚 || 向下滚
              event.preventDefault();
            }
          });
        });
      },
      showFooter(value) {

      }
    },
    created() {
      //通过维护一个sectionlist来渲染左侧导航栏中显示的标题
      if (this.ARTICLE.hasOwnProperty("abstracts") && this.ARTICLE.abstracts.length > 0) {
        this.sectionlist.push({
          "id": 'abstract',
          "label": '',
          "title": '摘要',
          "titleEn": 'Abstract',
          "level": '1',
        })
      }
      if (this.ARTICLE.hasOwnProperty("keyword") && this.ARTICLE.keyword.length > 0) {
        this.sectionlist.push({
          "id": 'keyword',
          "label": '',
          "title": '关键词',
          "titleEn": 'Keywords',
          "level": '1',
        })
      }
      if (this.ARTICLE.hasOwnProperty("ocis") && this.ARTICLE.ocis.length > 0) {
        this.sectionlist.push({
          "id": 'ocis',
          "label": '',
          "title": 'OCIS码',
          "titleEn": 'OCIS codes',
          "level": '1',
        })
      }
      if (this.ARTICLE.hasOwnProperty("highlights") && this.ARTICLE.highlights.length > 0) {
        this.sectionlist.push({
          "id": 'highlight',
          "label": '',
          "title": '要点',
          "titleEn": 'High lights',
          "level": '1',
        })
      }
      for (var i in this.body) {
        if (this.body[i].name == 'sec') {
          if (this.body[i].data[0].data.label && this.body[i].data[0].data.label.length>0 || this.body[i].data[0].data.title && this.body[i].data[0].data.title.length>0){
            this.sectionlist.push({
              "id": this.body[i].data[0].data.id,
              "label": this.body[i].data[0].data.label,
              "title": this.body[i].data[0].data.title,
              "level": this.body[i].data[0].data.level,
            })
          }
          for (var j in this.body[i].data) {
            if (this.body[i].data[j].name == 'sec') {
              if (this.body[i].data[j].data[0].data.label && this.body[i].data[j].data[0].data.label.length>0 ||
                this.body[i].data[j].data[0].data.title && this.body[i].data[j].data[0].data.title.length>0){
                this.sectionlist.push({
                  "id": this.body[i].data[j].data[0].data.id,
                  "label": this.body[i].data[j].data[0].data.label,
                  "title": this.body[i].data[j].data[0].data.title,
                  "level": this.body[i].data[j].data[0].data.level,
                })
              }
            }
          }
        }
      }
      if (this.ARTICLE.hasOwnProperty("response") && this.ARTICLE.response.length > 0) {
        for(let i in this.ARTICLE.response){
          if (this.ARTICLE.response[i].type && this.ARTICLE.response[i].type === 'comment'){
            this.sectionlist.push({
              "id": 'response',
              "label": '',
              "title": this.ARTICLE.defaultlang==='zh'?'专家点评':'Comments of Experts',
              "level": '1',
            });
            break;
          }
        }
      }
      if (this.ARTICLE.hasOwnProperty("contributions") && this.ARTICLE.contributions.length > 0) {
        for(let i=0;i<this.ARTICLE.contributions.length;i++) {
          if (this.ARTICLE.contributions[i].type === 'con') {
            this.sectionlist.push({
              "id": 'conandack',
              "label": '',
              "title": this.ARTICLE.defaultlang == 'zh' ? '作者贡献声明' : 'Contributions Statement',
              "level": '1',
            });
            break;
          }
        }
        for(let i=0;i<this.ARTICLE.contributions.length;i++){
          if (this.ARTICLE.contributions[i].type ==='equal'){
            this.sectionlist.push({
              "id": 'conandack-equal',
              "label": '',
              "title": this.ARTICLE.defaultlang=='zh'?'同等贡献声明':'Equal Contributions Statement',
              "level": '1',
            });
            break;
          }
        }
      }
      if (this.ARTICLE.hasOwnProperty("acknowledgements") && this.ARTICLE.acknowledgements.length > 0) {
        this.sectionlist.push({
          "id": 'acknowledgements',
          "label": '',
          "title": this.ARTICLE.defaultlang=='zh'?'致谢':'Acknowledgements',
          "level": '1',
        })
      }
      if (this.ARTICLE.supplementary && this.ARTICLE.supplementary.length > 0){
        for (let i in this.ARTICLE.supplementary) {
          for (let j in this.ARTICLE.supplementary[i].data) {
            if (this.ARTICLE.supplementary[i].data[j].name === 'sectitle') {
              this.sectionlist.push({
                "id": this.ARTICLE.supplementary[i].data[j].data.id,
                "label": this.ARTICLE.supplementary[i].data[j].data.label,
                "title": this.ARTICLE.supplementary[i].data[j].data.title,
                "level": this.ARTICLE.supplementary[i].data[j].data.level,
              })
            }
          }
        }
      }
      if (this.ARTICLE.hasOwnProperty("conflict") && this.ARTICLE.conflict.length > 0) {
        this.sectionlist.push({
          "id": 'conflict',
          "label": '',
          "title": this.ARTICLE.defaultlang=='zh'?'利益冲突':'Conflict of Interest',
          "level": '1',
        })
      }
      if (this.ARTICLE.hasOwnProperty("ethics") && this.ARTICLE.ethics.length > 0) {
        this.sectionlist.push({
          "id": 'ethics',
          "label": '',
          "title": this.ARTICLE.ethics[0].title && this.ARTICLE.ethics[0].title.length > 0 ? this.ARTICLE.ethics[0].title : (this.ARTICLE.defaultlang=='zh'?'伦理道德声明':'Ethical Statements'),
          "level": '1',
        })
      }
      if (this.ARTICLE.hasOwnProperty("supportedby") && this.ARTICLE.supportedby.length > 0) {
        this.sectionlist.push({
          "id": 'supportedby',
          "label": '',
          "title": this.ARTICLE.defaultlang=='zh'?'支撑数据':'Supportedby',
          "level": '1',
        })
      }
      if (this.ARTICLE.hasOwnProperty("glossary") && this.ARTICLE.glossary.data.length > 0) {
        this.sectionlist.push({
          "id": 'glossary',
          "label": '',
          "title": this.ARTICLE.glossary.title ? this.ARTICLE.glossary.title : (this.ARTICLE.defaultlang === 'zh' ? '符号说明' : 'Symbol Definition'),
          "level": '1',
        })
      }
      if (this.ARTICLE.hasOwnProperty("appendix") && this.ARTICLE.appendix.length > 0) {
        let title = this.ARTICLE.defaultlang === 'zh' ? '附录' : 'Appendix'
        this.sectionlist.push({
          "id": 'appendix',
          "label": '',
          "title": title,
          "level": '1',
        })
      }
      if (this.ARTICLE.hasOwnProperty("subArticles") && this.ARTICLE.subArticles.length > 0) {
          let subArticles = this.ARTICLE.subArticles;
          for (let i in subArticles) {
              if (subArticles[i].titlegroup && subArticles[i].titlegroup.articletitle) {
                this.sectionlist.push({
                  "id": subArticles[i].id,
                  "lable": '',
                  "title": subArticles[i].titlegroup.articletitle[0].data,
                  "level": '1',
                })
              }
              for (let j in subArticles[i].body) {
                  let item = subArticles[i].body[j];
                if (item.name == 'sec') {
                  if (item.data[0].data.label && item.data[0].data.label.length>0 ||
                    item.data[0].data.title && item.data[0].data.title.length>0){
                    this.sectionlist.push({
                      "id": item.data[0].data.id,
                      "label": item.data[0].data.label,
                      "title": item.data[0].data.title,
                      "level": item.data[0].data.level,
                    })
                  }
                }
              }
          }
      }
      if (this.ARTICLE.hasOwnProperty("reflist") && this.ARTICLE.reflist.data.length > 0) {
        let title = this.ARTICLE.defaultlang === 'zh' ? '参考文献' : 'References'
        this.sectionlist.push({
          "id": 'reference',
          "label": '',
          "title": (this.ARTICLE.reflist.title && this.ARTICLE.reflist.title.length > 0) ? this.ARTICLE.reflist.title : title,
          "level": '1',
        })
      }
    },
    activated() {
      window.addEventListener('scroll', this.handleScroll);
      this.topHeight = this.GLOBAL.topbarheight
      this.$bus.on('topbarheight', (heigth) => {
        this.topHeight = heigth;
      })
      this.clientHeight = $(window).height();
      $(window).resize(() => {
        this.clientHeight = $(window).height();
      })
      this.handleScroll()

      this.$bus.on('currentLang', (lang) => {
        this.lang = lang;
      })
    },
    deactivated() {
      window.removeEventListener('scroll', this.handleScroll)
    },
    watch: {
      currentSec(newValue, oldValue) {
        this.showNode(newValue)
      },
    },
    mounted(){
      if (this.sectionlist.length < 1) {
        this.$nextTick(function () {
          $('.jobody').css({'width': 'auto','margin-left':'20px'});
        })
      }
      var appDivBottom = $("#app").offset().top + $("#app").height()
      var documentHeight = $(document.body).height();
      console.log("appDivBottom:" + appDivBottom);
      console.log("documentHeight:" + documentHeight);
      var outSideFooterHeight = documentHeight - appDivBottom;
      if (outSideFooterHeight && outSideFooterHeight > 0) {
        this.outSideFooterHeight = outSideFooterHeight
      }
      this.scrollUpFixed();
    }
  }
</script>

<style lang="scss" scoped>
  @import "./../../../assets/css/mixins";

  .jo-sidebar {
    position: relative;
    width: 17%;
    top: 0;
    box-sizing: border-box;
    padding-top: 20px;
    margin-left: 20px;
    overflow-y: auto;
    @include screen(0px, 800px) {
      display: none;
    }
    .jo-catalog-title {
      padding: 0 0 15px 0;
      font-size: 1.8rem;
      color: #333;
      border-bottom: 2px solid #cccccc;
      span {
        margin-left: 10px;
        font-family: Arial;
        color: #999;
      }
    }
    .el-scrollbar {
      height: calc(100% - 70px);
    }
    .sidebar-item {
      padding: 10px 0;
      border-bottom: 1px solid #ffffff;
      border-left: 3px solid #efefef;
      font-size: 1.4rem;
      color: #454545;
      cursor: pointer;
      span.sidebar-item-span {
        display: block;
        width: 85%;
        padding-left: 15px;
      }
    }
    .sidebar-item:hover {
      background-color: #f9fafa;
    }
    .sidebar-item.grade-one {
      span {
        font-weight: bold;
      }
    }
    .sidebar-item.grade-two {
      margin-left: 20px;
    }
    .sidebar-item.current {
      border-left: 3px solid #00a2af;
      color: #00a2af;
      /*background: transparent url('../../../assets/img/arrow-small-right.png') no-repeat right center;*/
      span.sidebar-item-span {
        padding-left: 12px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/maincontent/sidebar/sidebar.vue